import Common from '../../Common';

interface Search {
	limit?: number | string
	limit_from?: number | string
	search?: string
	order_by?: string
	order_dir?: string
}

const GlobalSearch = class extends Common {
	browse = (userId: id, search: Search = {}) =>
		this.get(`/user/${userId}/globalsearch`, search)
}

export default GlobalSearch
